import React from 'react';
import {Link, useLocation} from "react-router-dom";
import MenuMainIcon from "./Images/MenuMainIcon";
import MenuTasksIcon from "./Images/MenuTasksIcon";
import MenuCodesIcon from "./Images/MenuCodesIcon";
import MenuReferralsIcon from "./Images/MenuReferralsIcon";
import styled from "styled-components";
import {useAppSelector} from "../hooks/hooks";
import {DaysDiffToNow} from "../utils/date-utils";

const Menu = () => {
    const userData = useAppSelector((state) => state.user.data)
    const { pathname } = useLocation();
    const counter = DaysDiffToNow('2024-11-01');

    return (
        <UlWrapper pathname={pathname}>
            <Ul>
                {!userData.has_checked_tutorial ?
                    <li style={pathname.includes('main') ? {} : {opacity: .2}}><Span active={pathname.includes('main') || pathname === '/'}><MenuMainIcon/></Span></li>
                    :
                    <li><Link to={`main`}><Span active={pathname.includes('main') || pathname === '/'}><MenuMainIcon/></Span></Link></li>
                }

                {!userData.has_checked_tutorial ?
                    <li style={pathname.includes('codes') ? {} : {opacity: .2}}><Span active={pathname.includes('codes')}><MenuCodesIcon/></Span></li>
                    :
                    <li><Link to={`codes`}><Span active={pathname.includes('codes')}><MenuCodesIcon/></Span></Link></li>
                }
                <li>
                    <OuterWrapper>
                        <InnerWrapper>
                            <CentralButton>
                                {counter <= 100 ? counter : 100}%
                            </CentralButton>
                        </InnerWrapper>
                    </OuterWrapper>
                </li>
                {!userData.has_checked_tutorial ?
                    <li style={pathname.includes('tasks') ? {} : {opacity: .2}}><Span active={pathname.includes('tasks')}><MenuTasksIcon/></Span></li>
                    :
                    <li><Link to={`tasks`}><Span active={pathname.includes('tasks')}><MenuTasksIcon/></Span></Link></li>
                }
                {!userData.has_checked_tutorial ?
                    <li style={pathname.includes('referral') ? {} : {opacity: .2}}><Span active={pathname.includes('referral')}><MenuReferralsIcon/></Span></li>
                    :
                    <li><Link to={`referral`}><Span active={pathname.includes('referral')}><MenuReferralsIcon/></Span></Link></li>
                }
            </Ul>
        </UlWrapper>
    );
};

export default Menu;

const Ul = styled.ul`
  list-style: none;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: space-between;
    margin: 17px 30px;
    position: relative;
`;
const UlWrapper = styled.div<{pathname:string}>`
    display: block;
    position: ${({pathname}) => (pathname === "/codes" || pathname === "/tutorial/codes") ? "relative" : "fixed"};
    bottom: 0;
    left:0;
    width: 100%;
    background-color: #000;
    z-index: 90
`;
const Span = styled.span<{ active: boolean; }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 46px;
    height: 46px;
    border: ${({active}) => active ? '2px solid #fff' : '2px solid transparent'}
`;
const OuterWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 62px;
    border: 1px solid rgba(255,255,255,.3);
    border-radius: 50%;
`;
const InnerWrapper = styled(OuterWrapper)`
    position: relative;
    width: 56px;
    height: 56px;
    border: 1px solid rgba(255,255,255,.5);
`;
const CentralButton = styled.div`
    font-size: 12px;
    font-weight: 400;
    font-family: 'ZenDots', sans-serif;
    &:after {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        content: '';
        width: 24px;
        height: 24px;
        border: 1px solid rgba(255,255,255,.1);
        border-radius: 50%;
    }
`;
